import { UCSymbolNames } from "../../../types/UCEnums";
import { SymbolResizeConfig } from "../../../types/UCInterfaces";

const config_M1: SymbolResizeConfig = {
    default: {
        scale: 0.5,
        offsetX: 3.5,
        offsetY: 3.5,
    }, //done
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 22,
    },
    x033: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 34,
    }, //done
    x075: {
        scale: 0.5,
        offsetX: 0,
        offsetY: 16,
    }, //done
};

const config_M2: SymbolResizeConfig = {
    default: {
        scale: 0.5,
        offsetX: 0,
        offsetY: 0,
    }, //done
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: -25,
    }, //done
    x033: {
        scale: 0.45,
        offsetX: 0,
        offsetY: -28,
    }, //done
    x075: {
        scale: 0.5,
        offsetX: 0,
        offsetY: -12,
    }, //done
};

const config_M3: SymbolResizeConfig = {
    default: {
        scale: 0.5,
        offsetX: 0,
        offsetY: 2,
    }, //done
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 9,
    }, //done,
    x033: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 18,
    }, //done
    x075: {
        scale: 0.45,
        offsetX: -4,
        offsetY: -4,
    }, //done
};

const config_F1: SymbolResizeConfig = {
    //stands for M4
    default: {
        scale: 0.5,
        offsetX: 0,
        offsetY: 51,
    }, //done,
    x025: {
        scale: 0.43,
        offsetX: 0,
        offsetY: 26,
    },
    x033: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 15,
    },
    x075: {
        scale: 0.5,
        offsetX: 0,
        offsetY: 38,
    }, //done
};

const config_M5: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 15,
    }, //done,
    x033: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 20,
    }, //done
    x075: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 0,
    }, //done
};

const config_L1: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: -20,
    }, //done
    x033: {
        scale: 0.45,
        offsetX: 8,
        offsetY: -20,
    }, //done
    x075: {
        scale: 0.5,
        offsetX: 8,
        offsetY: -13,
    }, //done
};

const config_L2: SymbolResizeConfig = {
    default: {
        scale: 0.5,
        offsetX: 3,
        offsetY: 0,
    }, //done
    x025: {
        scale: 0.44,
        offsetX: 0,
        offsetY: -2,
    }, //done
    x033: {
        scale: 0.44,
        offsetX: 4,
        offsetY: -10,
    }, //done
    x075: {
        scale: 0.5,
        offsetX: 5,
        offsetY: 4,
    }, //done
};

const config_L3: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.5,
        offsetX: 0,
        offsetY: 12,
    }, //done
    x033: {
        scale: 0.5,
        offsetX: 6,
        offsetY: 20,
    }, //done
    x075: {
        scale: 0.5,
        offsetX: 0,
        offsetY: 2,
    }, //done
};

const config_L4: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 0,
    }, //done
    x033: {
        scale: 0.43,
        offsetX: 5,
        offsetY: 0,
    }, //done
    x075: {
        scale: 0.5,
        offsetX: 2,
        offsetY: 5,
    }, //done
};

const config_L5: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.44,
        offsetX: 8,
        offsetY: 0,
    },
    x033: {
        scale: 0.44,
        offsetX: 12,
        offsetY: -2,
    },
    x075: {
        scale: 0.5,
        offsetX: 3,
        offsetY: -8,
    }, //done
};

const config_SCATTER: SymbolResizeConfig = {
    default: {
        scale: 0.5,
        offsetX: 0,
        offsetY: -1,
    }, //done
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 10,
    }, //done
    x033: {
        scale: 0.38,
        offsetX: 0,
        offsetY: -5,
    }, //done
    x075: {
        scale: 0.46,
        offsetX: -1,
        offsetY: -7,
    }, //done
};

const config_MYSTERY: SymbolResizeConfig = {
    default: {
        scale: 0.5,
        offsetX: -1,
        offsetY: 55,
    },
    x025: {
        scale: 0.5,
        offsetX: 0,
        offsetY: 0,
    },
    x033: {
        scale: 0.5,
        offsetX: 0,
        offsetY: 0,
    },
    x075: {
        scale: 0.5,
        offsetX: 0,
        offsetY: 0,
    }, //done
};

const config_WILD: SymbolResizeConfig = {
    default: {
        scale: 0.5,
        offsetX: 0.5,
        offsetY: 1,
    }, //done
    x025: {
        scale: 0.44,
        offsetX: 0,
        offsetY: -22,
    },
    x033: {
        scale: 0.44,
        offsetX: 0,
        offsetY: -15,
    },
    x075: {
        scale: 0.5,
        offsetX: 0,
        offsetY: -3,
    }, //done
};

const config_BIG_FISH: SymbolResizeConfig = {
    default: {
        scale: 0.5,
        offsetX: 3,
        offsetY: -4,
    }, //done
    x025: {
        scale: 0.38,
        offsetX: 0,
        offsetY: 8,
    },
    x033: {
        scale: 0.36,
        offsetX: 0,
        offsetY: 9,
    },
    x075: {
        scale: 0.5,
        offsetX: 4,
        offsetY: 8,
    }, //done
};

export const symbolsResizeConfig: Map<UCSymbolNames, SymbolResizeConfig> = new Map([
    [UCSymbolNames.M1, config_M1],
    [UCSymbolNames.M2, config_M2],
    [UCSymbolNames.M3, config_M3],
    [UCSymbolNames.F1, config_F1],
    [UCSymbolNames.F2, config_F1],
    [UCSymbolNames.F3, config_F1],
    [UCSymbolNames.F4, config_F1],
    [UCSymbolNames.F5, config_F1],
    [UCSymbolNames.F6, config_F1],
    [UCSymbolNames.F7, config_F1],
    [UCSymbolNames.M5, config_M5],
    [UCSymbolNames.L1, config_L1],
    [UCSymbolNames.L2, config_L2],
    [UCSymbolNames.L3, config_L3],
    [UCSymbolNames.L4, config_L4],
    [UCSymbolNames.L5, config_L5],
    [UCSymbolNames.SCATTER, config_SCATTER],
    [UCSymbolNames.MYSTERY, config_MYSTERY],
    [UCSymbolNames.WILD, config_WILD],
    [UCSymbolNames.BIG_FISH, config_BIG_FISH],
]);
